import FirebaseContext, { withFirebase } from "./context"
import { firebase } from "firebase/app"
import { getFirebase } from "./firebase"
import { onAuthUserListener } from "./firebase"
export default firebase

export { FirebaseContext, withFirebase, getFirebase, onAuthUserListener }
